<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
            <div class="header-body">
                <div class="row align-items-center py-4">
                    <div class="col-lg-4 col-4">
                    <h2>SERVICES</h2>
                    </div>
                    <div class="col-lg-8 col-8 text-right bid">
                        
                    </div>
                </div>
                
            </div>
            </div>
        </div>
        <div class="container-fluid mt--6 dashboard" >
            <div class="row">
                 <div class="col-xl-12">
                    <div class="card vh-75" id="scroll">
                        <div class="table-responsive">
                        <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                        <table class="table align-items-center table-flush table-hover bidtbl ecntbl">
                            <thead class="thead-light psticky">
                            <tr>
                                <th 
                                    scope="col" 
                                    class="sort"
                                    >SERVICE</th> 
                                    <th 
                                    scope="col" 
                                    class="sort"
                                    >description</th>
                                    <th 
                                    scope="col" 
                                    class="sort"
                                    >STATUS</th>
                                    <th 
                                    scope="col" 
                                    class="sort"
                                    >LAST STATUS</th>
                                    <th 
                                    scope="col" 
                                    class="sort"
                                    >START TIME</th>
                                    <th 
                                    scope="col" 
                                    class="sort"
                                    >STOP TIME</th>
                                    
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                    >ACTION</th>                           
                               
                            </tr>
                            </thead>
                            <tbody class="list no-cursor">
                            <tr v-if="services.length == 0 && !loading">
                                <td><p class="nodata">No data available</p>
                            </td>
                            </tr>
                            <tr v-for="service in services" :key="service.id" >
                                <td>
                                    <span class="text-primary">{{service.name}}</span><br>
                                </td>
                                <td class="text-wrap">
                                    <span>{{service.description}}</span><br>
                                </td>
                                <td> 
                                    <span v-if="service.desiredCount" class="text-success">ACTIVE</span>                     
                                    <span v-if="!service.desiredCount" class="text-danger">INACTIVE</span>                     
                                </td>
                                <td>
                                    <ul>
                                        <li v-for="(status, task) in service.lastStatus" :key="task" :style="{ color: getStatusColor(status) }">
                                        {{ task }}: {{ status }}
                                        </li>
                                    </ul>    
                                    <!-- <span v-if="service.version" class="text-info">{{service.version}} : {{service.lastUpdatedOn}}</span><br> -->
                                </td>
                                <td>
                                    <span><input type="time" class="form-control mt-2" v-model="service.startTime" id="appt"  step="1" name="appt"></span>
                                    <!-- <span v-if="!service.startTime">N/A</span> -->
                                </td>
                                <td>
                                    <span>  <input type="time" class="form-control mt-2" v-model="service.stopTime" id="appt"  step="1" name="appt"></span>
                                </td>
                                <td class="text-center">
                                    <button v-if="!service.desiredCount" @click="updateService(service)" class="btn btn-success">START</button>
                                    <button v-if="service.desiredCount" @click="updateService(service)" class="btn btn-danger">STOP</button>
                                    <button @click="update(service)" class="btn btn-info">UPDATE</button>
                                    <button v-if="service.desiredCount" @click="restartService(service)" class="btn btn-warning">RESTART</button>
                                </td>
                            </tr>
                            </tbody>
                        </table>                      
                        </div>
                    </div>
                    </div>
            </div>
        </div>
       
    </div>     
</template>
<script>
import authService from "@/authService";
import config from "@/config";
export default {
  name: "imsComponent",
  components : {
   
  },
  data() {
    return {
        accessToken:null,
        loading : false,
        services : []
    };
  },
  methods: {
    getStatusColor(status) {
      return status === "RUNNING" ? "green" : "red";
    },
    update(service){
        var message = `Are you sure you want to update?` ;
        var postData = [{
                "name": service.name,
                "desiredCount": service.desiredCount,
                "startTime": service.startTime, 
                "stopTime": service.stopTime,
                "utcOffsetSeconds": new Date().getTimezoneOffset() * -60
            }]
        this.$confirm(message,"","question",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
            const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            this.loading = true;
            this.$http
                .put(
                config.baseUrlAutoBidder +
                    "/ecs/update-service",postData,
                    auth
                )
                .then(() => {
                this.loading = false;
                this.$alert(`Service updated`,"","success");
                this.getServices()
                })
            })
    }, 
    updateService(service){
        var message = `Are you sure you want to ${service.desiredCount ? 'stop service' : 'start service'}?` ;
        var postData = [{
                "name": service.name,
                "desiredCount": service.desiredCount ? 0 : 1,
                "startTime": service.startTime, 
                "stopTime": service.stopTime,
                 "utcOffsetSeconds": new Date().getTimezoneOffset() * -60
            }]
        this.$confirm(message,"","question",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
            const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            this.loading = true;
            this.$http
                .put(
                config.baseUrlAutoBidder +
                    "/ecs/update-service",postData,
                    auth
                )
                .then(() => {
                this.loading = false;
                this.$alert(`Service ${service.desiredCount ? 'Stopped Successfully' : 'Started Successfully'}.`,"","success");
                this.getServices()
                })
            })
    },  
    restartService(service){
        var message = `Are you sure you want to restart service?` ;
        var postData = [{
                "name": service.name,
                "desiredCount": service.desiredCount ? 0 : 1
            }]
        this.$confirm(message,"","question",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
            const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            this.loading = true;
            this.$http
                .put(
                config.baseUrlAutoBidder +
                    "/ecs/restart-service",postData,
                    auth
                )
                .then(() => {
                    this.loading = false;
                    this.$alert("Service Restarted Successfully.","","success");
                    this.getServices()

                })
            })
    }, 
    getServices(){
        this.loading = true;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlAutoBidder +
            "/ecs/list-service?utcOffsetSeconds="+new Date().getTimezoneOffset() * -60,
            auth
        )
        .then(result => {
          this.services = result.data;
          this.loading = false;
        })        
    },
  },
  mounted() {
    
  },
  created () {
    this.getServices();
 }
};
</script>
<style scoped>
button.btn-danger,button.btn-warning,button.btn-success {
    min-width: 60px;
}
</style>
